import { Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SearchTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.grey[200],
  borderColor: theme.palette.grey[700],
  borderRadius: '6px',
  '& input': {
    color: theme.palette.grey[700],
  },
}));

const SearchButton = styled(Button)(({ theme }) => ({
  color: '#fff',
  backgroundColor: theme.palette.primary.main,
  boxShadow: 'none',
  '&:hover': {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
  },
}));

const MainSection = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  paddingRight: '20px',
});

const FilterSection = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
});

const Count = styled(Typography)({
  color: '#434546',
  fontSize: '16px',
  fontWeight: 500,
});

const TableFilter = ({ search, handleChange, setLoad, count, setPage }) => {
  const handleSearch = () => {
    setPage(0);
    setLoad(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <MainSection>
      <FilterSection>
        <SearchTextField
          type="text"
          id="search-mobile-number"
          value={search}
          onChange={(event) => handleChange(event.target.value)}
          onKeyDown={handleKeyDown}
          size="small"
          placeholder="Search by Mobile Number"
          variant="outlined"
          inputProps={{ inputMode: 'numeric', 'aria-label': 'Search by mobile number' }}
        />
        <SearchButton variant="contained" size="medium" onClick={handleSearch}>
          Search
        </SearchButton>
      </FilterSection>

      <Count>Total Numbers: {count}</Count>
    </MainSection>
  );
};

export default TableFilter;
